// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_28zqW){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_TJoRz .dualColumn_EqJZH{display:flex;align-content:space-between}.nsAddressForm_TJoRz .dualColumn_EqJZH .firstCol_oAGSQ{margin-right:20px}.optional_EPeoG{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_28zqW",
	"nsAddressForm": "nsAddressForm_TJoRz",
	"dualColumn": "dualColumn_EqJZH",
	"firstCol": "firstCol_oAGSQ",
	"optional": "optional_EPeoG"
};
module.exports = exports;
